import { useRef, useState } from 'react'

import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import Clickable from '@web/components/Clickable'
import { ReviewGroup } from '@web/gql/graphql'
import { reactionTypeMap } from '@web/types/reaction-type'

import { REACTION_LOTTIE_MAP, ReactionLottieType } from '../reaction.constant'
import styles from './ReactionLottie.module.scss'

interface Props {
  reactionType: ReactionLottieType
  myReactionType?: ReviewGroup['myReactionType']
  updateReaction: (reactionType: string) => Promise<void>
  closeReactionLayer: () => void
  nClickCode: string
}

const ReactionLottie = ({ reactionType, myReactionType, updateReaction, closeReactionLayer, nClickCode }: Props) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null)
  const [isSelected, setIsSelected] = useState<boolean>(false)

  const LottieAnimation = REACTION_LOTTIE_MAP[reactionType]
  const reaction = reactionTypeMap.get(reactionType)
  if (!reaction) {
    return null
  }

  const isMyReactionType = reactionType === myReactionType

  const handleClickReaction = async () => {
    const isCancelReaction = isMyReactionType

    if (isCancelReaction) {
      lottieRef.current?.animationContainerRef.current?.classList.remove(styles.resize)
      lottieRef.current?.stop()
      await updateReaction(reactionType).then(() => closeReactionLayer())
    } else {
      lottieRef.current?.animationContainerRef.current?.classList.add(styles.resize)
      setIsSelected(true)
      await updateReaction(reactionType)
    }
  }

  return (
    <Clickable
      className={styles.btn}
      aria-pressed={isMyReactionType}
      onClick={handleClickReaction}
      nClickCode={nClickCode}
    >
      <Lottie
        lottieRef={lottieRef}
        className={styles.emoji}
        animationData={LottieAnimation}
        autoplay={!myReactionType || isMyReactionType}
        loop={isMyReactionType}
        onLoopComplete={() => {
          if (isSelected) closeReactionLayer()
        }}
      />
      {reaction.label.ko}
    </Clickable>
  )
}

export default ReactionLottie
